import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {CompanyApplicationAccessService} from '../../services/company-application-access.service';

/**
 * Доступ к разделу по appList$: route.data.appName (как hasAccessToAppGuard).
 */
@Injectable()
export class CompanyApplicationAccessGuard {

    constructor(
        private readonly access: CompanyApplicationAccessService,
        private readonly router: Router,
    ) {
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        _state: RouterStateSnapshot,
    ): boolean | Observable<boolean> {
        const appName = this.resolveAppName(route);
        if (!appName) {
            this.router.navigate(['404']);
            return false;
        }

        return this.access.ensureEnabled(appName).pipe(
            map((enabled) => {
                if (enabled) {
                    return true;
                }
                this.router.navigate(['404']);
                return false;
            }),
        );
    }

    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): boolean | Observable<boolean> {
        return this.canActivate(childRoute, state);
    }

    private resolveAppName(route: ActivatedRouteSnapshot): string | null {
        let current: ActivatedRouteSnapshot | null = route;
        while (current) {
            const appName = current.data?.appName;
            if (appName) {
                return appName;
            }
            current = current.parent;
        }
        return null;
    }
}
